import React from 'react';
import { Typography, Tooltip } from '@mui/material';
import Locale from 'src/i18n';
import { formatMessage } from 'src/i18n/intl';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import size from 'lodash/size';
import PropTypes from 'prop-types';

const getTooltipContent = (userRolesNames = [], email) => {
    let identityRoleTooltipContent = '';

    const tooltipRoleNames = userRolesNames.slice(1);
    identityRoleTooltipContent = map(tooltipRoleNames, roleName => <p key={`${email}-${roleName}`}>{roleName}</p>);

    return identityRoleTooltipContent;
};

const UserRolesColumn = ({ userRoles, email }) => {
    const userRolesNames = map(userRoles, userRole => {
        return userRole?.name;
    });

    if (isEmpty(userRoles)) {
        return (
            <Typography variant="tableCell" noWrap>
                {formatMessage(Locale.unassigned)}
            </Typography>
        );
    }
    return (
        <>
            <Tooltip type="standard" title={userRoles[0]?.name} arrow>
                <Typography variant="tableCell" noWrap>
                    {userRoles[0]?.name}
                </Typography>
            </Tooltip>
            {size(userRolesNames) > 1 && (
                <Tooltip type="standard" title={getTooltipContent(userRolesNames, email)} arrow>
                    <Typography variant="tableCell">{`...[+${size(userRoles) - 1}]`}</Typography>
                </Tooltip>
            )}
        </>
    );
};

UserRolesColumn.propTypes = {
    userRoles: PropTypes.arrayOf({}),
    email: PropTypes.string,
};

UserRolesColumn.defaultProps = {
    userRoles: [],
    email: '',
};

export default UserRolesColumn;
